module.exports = __webpack_public_path__ + "static/media/csm-star-icon.336d8177.svg";